/**
 * Chat-related constants for the UI layer.
 */

/** Character threshold for showing tool output inline vs collapsed */
export const TOOL_INLINE_THRESHOLD = 80;

/** Maximum lines to show in collapsed preview */
export const PREVIEW_MAX_LINES = 2;

/** Maximum characters to show in collapsed preview */
export const PREVIEW_MAX_CHARS = 100;
